<body>
  <div class="social-image">
    <a
      href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
      target="_blank"
      rel="noopener"
    >
      <img
        src="{{ onPassiveBaseUrl }}onpassive(dec-23)/assets/image/icon/fb1.png"
        alt="facebook"
        title="Facebook"
        class="fb"
      />
    </a>
    <a href="https://twitter.com/ONPASSIVE" target="_blank" rel="noopener">
      <img
        src="{{
          onPassiveBaseUrl
        }}onpassive(dec-23)/assets/image/icon/twitter.png"
        title="Twitter"
        class="twitter"
        alt="Twitter"
      />
    </a>
    <a
      href="https://www.instagram.com/ONPASSIVE/"
      target="_blank"
      rel="noopener"
    >
      <img
        src="{{
          onPassiveBaseUrl
        }}onpassive(dec-23)/assets/image/icon/insta.png"
        title="Instagram"
        class="insta"
      />
    </a>
    <a
      href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
      target="_blank"
      rel="noopener"
    >
      <img
        src="{{
          onPassiveBaseUrl
        }}onpassive(dec-23)/assets/image/icon/youtube.png"
        title="Youtube"
        class="youtube"
      />
    </a>
    <a
      href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
      target="_blank"
      rel="noopener"
    >
      <img
        src="{{ onPassiveBaseUrl }}onpassive(dec-23)/assets/image/icon/in.png"
        title="LinkedIn"
        class="linkedin"
      />
    </a>
    <a href="http://onpassive.com/blog" target="_blank" rel="noopener">
      <img
        src="{{ onPassiveBaseUrl }}onpassive(dec-23)/assets/image/icon/blog.png"
        title="ONPASSIVE Blog"
        class="blog"
      />
    </a>
    <!--   <a href="#">
             <img src="onpassive(dec-2)/image/icon/pin.png"title="Pinterest" class="icon">
             </a>-->
  </div>
  <section class="background">
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
 
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-9">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div class="logo text-center">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-23)/assets/image/logo.png"
                />
              </div>
              <div class="content mt-3">
                <h3 class="content2" data-aos-easing="ease-out-cubic">
                  Innovative Internet
                  <span class="revolutionized">Marketing Solutions </span
                  ><br />To Redefine Marketing
                </h3>
                <h3 class="content1" data-aos-easing="linear">
                  <h1 class="content3 text-center">LAUNCHING SOON!</h1>
                  <p class="content4">
                    Gift of time and love are basic ingredients of a truly Merry
                    Christmas. ONPASSIVE specializes in building AI-powered
                    marketing tools. Get your family and yourself the most
                    precious gift - time and love by working with the ONPASSIVE
                    community. A fully-fledged automated marketing business is
                    waiting for you just around the corner. Grab it before it is
                    too late.
                  </p>
                </h3>
              </div>
              <div class="video-box">
                <video
                  id="my-video"
                  class="
                    video-js video-size
                    w-100
                    h-auto
                    my-video-dimensions
                    shadow
                  "
                  controls
                  preload="auto"
                  poster="{{ myLinksS3URL }}images/Image0231.png"
                  data-setup="{}"
                  autoplay="true"
                  muted
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video2.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                target="_blank"
                rel="noopener"
                class="chirtmas"
                >BECOME A FOUNDER NOW</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</body>
